import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { usePageLayoutProperties } from '~layouts';

import OrganisationTransactionsSummaryDataGrid from '../components/dataGrids/organisationTransactionsSummaryDataGrid';

interface OrganisationTransactionsSummaryContainerProps {
	date: Date;
}

const OrganisationTransactionsSummaryContainer = ({
	date,
}: OrganisationTransactionsSummaryContainerProps) => {
	const { i18n } = useTranslation();
	const { setPageTitle } = usePageLayoutProperties();

	useEffect(() => {
		setPageTitle(date.toLocaleString(i18n.language, { month: 'long', year: 'numeric' }));
	}, [date, i18n.language, setPageTitle]);

	return <OrganisationTransactionsSummaryDataGrid date={date} />;
};

export default OrganisationTransactionsSummaryContainer;
